import { render, staticRenderFns } from "./BaseWidgetTitle.vue?vue&type=template&id=3ea6bb58&scoped=true"
import script from "./BaseWidgetTitle.vue?vue&type=script&lang=js"
export * from "./BaseWidgetTitle.vue?vue&type=script&lang=js"
import style0 from "./BaseWidgetTitle.vue?vue&type=style&index=0&id=3ea6bb58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea6bb58",
  null
  
)

export default component.exports